// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChartjsExtensionService } from '@coa/app/shared/chart-js/chartjs-extension.service';
import { SvgIconService } from '@coa/app/core/services/svg-icon.service';

@Component({
  selector: 'coa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  constructor(
    private translateService: TranslateService,
    private chartjsExtensionService: ChartjsExtensionService,
    private svgIconService: SvgIconService,
  ) {
  }

  ngOnInit(): void {
    this.translateService.setDefaultLang('en');
    this.chartjsExtensionService.addSpyLineChartDefinition();
    this.svgIconService.addSvgIconsToRegistry();
  }
}
